interface MovieIframeProps {
  movieUrl: string | undefined;
  movieStyle: Record<string, unknown>;
}
export const MovieIframe: React.FC<MovieIframeProps> = ({ movieUrl: movieUrl, movieStyle: movieStyle }) => {
  return (
    <iframe
      src={movieUrl}
      style={movieStyle}
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    ></iframe>
  );
};
